import React from "react";

import { useTranslation, Trans } from "react-i18next";

import y1 from '../../img/Home/y1.png';
import y2 from '../../img/Home/y2.png';
import Button from '../Button'

import Fade from 'react-reveal/Fade';

function YourTradingJourney () {

    const { t } = useTranslation();
      
    return(
        <div className="relative overflow-hidden">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto pt-[100px] xl:pt-[160px] pb-[80px] xl:pb-[160px]">  
                <div className="h-[271px] rounded-[20px] bg-[#353535] flex justify-center xl:justify-between relative overflow-hidden">
                    <Fade left delay={500}><img src={y1} alt="" className="hidden xl:block"/></Fade>
                    <div className="flex flex-col items-center justify-center">
                        <p className="merriweather text-center xl:text-[40px] text-white text-[23px] italic font-[700]"><Trans>{t('home.47')}</Trans></p>
                        <Button className={"mt-[25px]"}/>
                    </div>
                    <Fade right delay={500}><img src={y2} alt="" className="hidden xl:block"/></Fade>
                </div>
                <div className="mt-[40px] flex flex-col sm:flex-row justify-between gap-[10px] xl:gap-0">
                    <div className="flex items-center bg-[#0BD752] rounded-[12px] xl:rounded-[6px] sm:w-[350px] gap-[11px] xl:gap-0 justify-center xl:justify-normal">
                        <p className="inter font-[700] text-[30px] xl:text-[40px] text-white xl:pl-[10px]">01</p>
                        <p className="inter font-[700] xl:text-[20px] text-[14px] text-white xl:pl-[25px] xl:pr-[50px]">{t('home.48')}</p>
                    </div>
                    <div className="flex items-center bg-[#0BD752] rounded-[12px] xl:rounded-[6px] sm:w-[350px] gap-[11px] xl:gap-0 justify-center xl:justify-normal">
                        <p className="inter font-[700] text-[30px] xl:text-[40px] text-white xl:pl-[10px]">02</p>
                        <p className="inter font-[700] xl:text-[20px] text-[14px] text-white xl:pl-[25px] xl:pr-[50px]">{t('home.49')}</p>
                    </div>
                    <div className="flex items-center bg-[#0BD752] rounded-[12px] xl:rounded-[6px] sm:w-[350px] gap-[11px] xl:gap-0 justify-center xl:justify-normal">
                        <p className="inter font-[700] text-[30px] xl:text-[40px] text-white xl:pl-[10px]">03</p>
                        <p className="inter font-[700] xl:text-[20px] text-[14px] text-white xl:pl-[25px] xl:pr-[50px]">{t('home.50')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default YourTradingJourney;